<!-- eslint-disable -->
<template>
  <div>
    <div id="landing-page">
      <div class="grid-area-number-1">
        <TabBar></TabBar>
      </div>
    </div>
    <div>
      <HaveAQuestion />
      <LandingPageFooter />
    </div>
  </div>
  <!-- grid-template-columns: 80px auto 1rem; -->
</template>

<script>
// @ is an alias to /src
import LandingPageFooter from "../components/LandingPage/LandingPageFooter";
import HaveAQuestion from "../components/LandingPage/HaveAQuestion.vue";

import TabBar from "../components/Common/TabBar.vue";
import { mapGetters } from "vuex";

export default {
  name: "LandingPage",
  components: {
    LandingPageFooter,
    HaveAQuestion,
    TabBar,
  },
  computed: {
    ...mapGetters(["featureFlags"]),
  },
  methods: {
    enrollLinkClick() {
      this.$router.push({ name: "enroll" });
    },

    registerLoginLinkClick() {
      window.location = "https://banking.commercebank.com";
    },
  },
};
</script>
<style lang="scss" scoped>
#landing-page {
  overflow: hidden;
  // margin: 4.3vh;
}
</style>
